var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.link
      ? _c(
          "div",
          [
            _vm.checkLink(_vm.link)
              ? _c(
                  "a",
                  {
                    staticClass: "button",
                    class: [
                      _vm.disable && "disabled",
                      _vm.styleClass ? _vm.styleClass : "default",
                    ],
                    attrs: { href: _vm.link, target: "_blank" },
                  },
                  [
                    _c("span", { staticClass: "button__text" }, [
                      _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
                    ]),
                  ]
                )
              : _c(
                  "nuxt-link",
                  {
                    staticClass: "button",
                    class: [
                      _vm.disable && "disabled",
                      _vm.styleClass ? _vm.styleClass : "default",
                    ],
                    attrs: { to: _vm.link },
                  },
                  [
                    _c("span", { staticClass: "button__text" }, [
                      _vm._v("\n        " + _vm._s(_vm.text) + "\n      "),
                    ]),
                  ]
                ),
          ],
          1
        )
      : _c(
          "button",
          {
            staticClass: "button",
            class: [
              _vm.disable && "disabled",
              _vm.styleClass ? _vm.styleClass : "default",
            ],
            attrs: { disabled: _vm.disable },
            on: { click: _vm.handleClick },
          },
          [
            _c("span", { staticClass: "button__text" }, [
              _vm._v("\n      " + _vm._s(_vm.text) + "\n    "),
            ]),
            _vm._v(" "),
            _vm._t("default"),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }